import React, { useState } from 'react';
import AppLayout from '../common/layouts/appLayout';
import { Box } from '../styles/globalStyle';
import { OverrideStyles } from '../transactionPages/purchaseFunds/purchaseContainer';
import { theme} from '@pfmam/pfmam';
import { ABALookup } from './components/abaLookupComponent';
import { VerifyABALookupComponent } from './components/verifyABALookupComponent';
import { NotAnMatchComponent } from './components/notAnMatchComponent'
import { useParams,Redirect } from 'react-router-dom';


const ABALookUpContainer = (props) => {
  const [step, setStep] = useState(1);
  const [bankNumbers, setBankNumbers] = useState([]);
  const {accountType}=useParams();
  const acceptedAccTypes=['ach','wire']
  if (!acceptedAccTypes.includes(accountType)) {
   return <Redirect to="/404" />;
  }
  return (
    <>
    <OverrideStyles />
    <AppLayout>
      <Box maxwidth={"600px"} width="100%" margin="0 auto" padding="30px 0 0">
      <Box
        border={`1px solid ${theme.colors.grey_fossil}`}
        display="flex"
        padding="25px 32px"
        minwidth="100%"
        maxwidth="100%"
        flexdirection="column"
        boxcolor={theme.colors.white}
      >
    {step === 1 && <ABALookup accountType={accountType} setBankNumbers={setBankNumbers} setStep={setStep}/>}
     {step === 2 && (
        <VerifyABALookupComponent accountType={accountType} bankNumbers={bankNumbers} setStep={setStep}/>
      )}
     {step === 3 && (
        <NotAnMatchComponent accountType={accountType} setStep={setStep}  />
      )}
      </Box>
      </Box>
    </AppLayout>
    </>
  );
};

export default ABALookUpContainer;
